<template>
  <v-app>
    <transition>
      <keep-alive>
        <v-slide-y-transition mode="out-in">
          <router-view></router-view>
        </v-slide-y-transition>
      </keep-alive>
    </transition>
  </v-app>  
</template>

<script>
export default {
  name: 'AuthLayout',
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'createNewAccount'],
    }
  },  
}
</script>
